import React from "react";
import styles from "./cardsContainer.module.scss";
const CardsContainer = ({ children, }) => {
    return (React.createElement("div", { className: styles["cards-container"] },
        React.createElement("div", { className: styles.island }, children)));
};
export default CardsContainer;
//# sourceMappingURL=CardsContainer.js.map